export default __webpack_public_path__ + "static/media/image-ph-health-briefing-m.8017da14.webp";